export default __webpack_public_path__ + "static/media/border-bg-sm.48a67c5a.png";